import api, {handleAPIErrors} from 'shared/api'

const FETCH_REQUEST = 'bookmarks/FETCH_REQUEST'
const FETCH_SUCCESS = 'bookmarks/FETCH_SUCCESS'
const FETCH_FAILURE = 'bookmarks/FETCH_FAILURE'
const CREATE_REQUEST = 'bookmarks/CREATE_REQUEST'
const CREATE_SUCCESS = 'bookmarks/CREATE_SUCCESS'
const CREATE_FAILURE = 'bookmarks/CREATE_FAILURE'
const UPDATE_REQUEST = 'bookmarks/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'bookmarks/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'bookmarks/UPDATE_FAILURE'
const DELETE_REQUEST = 'bookmarks/DELETE_REQUEST'
const DELETE_SUCCESS = 'bookmarks/DELETE_SUCCESS'
const DELETE_FAILURE = 'bookmarks/DELETE_FAILURE'

const initialState = {
  result: [],
  loading: false,
  loaded: false,
  creating: false,
  created: false,
  updating: false,
  updated: false,
  deleting: false,
  deleted: false,
  errors: {}
}

export function fetchRequest() {
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload) {
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest() {
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(payload) {
  return {
    type: CREATE_SUCCESS,
    payload,
  }
}

export function createFailure(errors) {
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest() {
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(payload) {
  return {
    type: UPDATE_SUCCESS,
    payload,
  }
}

export function updateFailure(errors) {
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

export function deleteRequest() {
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess(payload) {
  return {
    type: DELETE_SUCCESS,
    payload,
  }
}

export function deleteFailure(errors) {
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

export function loadBookmarks(options) {
  return (dispatch) => {
    dispatch(fetchRequest())

    return api(`api/v1/bookmarks`, options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchFailure(errors))
        })
      })
  }
}

export function createBookmark(options = {}) {
  const config = {
    method: 'POST',
    body: JSON.stringify(options)
  }

  return (dispatch) => {
    dispatch(createRequest())

    return api(`api/v1/bookmarks`, {}, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(createSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(createFailure(errors))
        })
      })
  }
}

export function updateBookmark(id, options = {}) {
  const config = {
    method: 'PATCH',
    body: JSON.stringify(options)
  }

  return (dispatch) => {
    dispatch(updateRequest())

    return api(`api/v1/bookmarks/${id}`, {}, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(updateSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(updateFailure(errors))
        })
      })
  }
}

export function deleteBookmark(id) {
  const config = {
    method: 'DELETE',
  }

  return (dispatch) => {
    dispatch(deleteRequest())

    return api(`api/v1/bookmarks/${id}`, {}, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(deleteSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(deleteFailure(errors))
        })
      })
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action

  switch (type) {
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true
      })
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: [],
        result: payload
      })
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        result: {
          ...state.result
        },
        errors: errors
      }
    case CREATE_REQUEST:
      return Object.assign({}, state, {
        creating: true
      })
    case CREATE_SUCCESS:
      return Object.assign({}, state, {
        creating: false,
        created: true,
        errors: [],
        result: [payload, ...state.result]
      })
    case CREATE_FAILURE:
      return {
        ...state,
        errors: errors,
        creating: false,
        created: false,
        result: [...state.result]
      }
    case UPDATE_REQUEST:
      return Object.assign({}, state, {
        updating: true
      })
    case UPDATE_SUCCESS:
      const updatedIndex = state.result.findIndex(i => i.id === payload.id)
      return Object.assign({}, state, {
        updating: false,
        updated: true,
        errors: [],
        result: Object.assign([...state.result], {[updatedIndex]: payload})
      })
    case UPDATE_FAILURE:
      return {
        ...state,
        errors: errors,
        updating: false,
        updated: false,
        result: [...state.result]
      }
    case DELETE_REQUEST:
      return Object.assign({}, state, {
        deleting: true
      })
    case DELETE_SUCCESS:
      return Object.assign({}, state, {
        deleting: false,
        deleted: true,
        errors: [],
        result: state.result.filter( i => i.id !== payload.id )
      })
    case DELETE_FAILURE:
      return {
        ...state,
        errors: errors,
        deleting: false,
        deleted: false,
        result: [...state.result]
      }
    default:
      return state
  }
}

